import React from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import darssyTheme from "../../theme/darssyTheme";
import { pageGradientBackground } from "../../theme/tokens";
import StudentNavbar from "../StudentNavbar";
import StudentSidebar from "./StudentSidebar";

// Shell for the redesigned student pages: a full-height sidebar (with its
// own logo header) to the left, and a right-hand column holding a sticky
// top bar + a scrollable content slot — the sidebar sits in front, the top
// bar only spans the remaining width instead of the whole page, so the two
// never fight over the corner where they'd otherwise overlap.
// ThemeProvider is mounted here only, so it never affects pages that
// don't render through this layout.
// `fullHeight`: for pages with their own internal scroll region (e.g. a
// chat panel) instead of a normally-scrolling page — the content slot
// gets an exact height and no padding instead of flexible/padded/scrollable.
export default function StudentLayout({ children, fullHeight = false }) {
  return (
    <ThemeProvider theme={darssyTheme}>
      <CssBaseline />
      <Box
        sx={{
          background: pageGradientBackground,
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          height: fullHeight ? "100vh" : "auto",
          minHeight: "100vh",
        }}
      >
        <StudentSidebar />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            minWidth: 0,
            height: fullHeight ? "100vh" : "auto",
            overflow: fullHeight ? "hidden" : "visible",
          }}
        >
          <StudentNavbar fixed />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              minWidth: 0,
              ...(fullHeight
                ? { p: 0, height: "100%", minHeight: 0, overflow: "hidden" }
                : { p: { xs: 2, md: 4 } }),
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
